<template>
  <div>
    <quill-editor
      v-model="editorContent"
      :options="editorOption"
      :auto-focus="false"
      :disabled="disableQuill"
      :class="{ validationError: showError }"
    >
    </quill-editor>
  </div>
</template>
<script>
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import { required, maxLength } from "vuelidate/lib/validators";
export default {
  name: "QuillEditor",
  components: {
    quillEditor,
  },
  props: {
    value: String,
    addquesProp: Boolean,
    disableQuill: Boolean,
    placeHolder: String,
    showError: Boolean,
  },
  validations: {
    editorContent: {
      required,
      maxLength: maxLength(1024),
    },
  },
  data() {
    return {
      // editorEnabled: this.disableQuill, // Initially, the editor is enabled
      editorContent: this.value,
      changeaddquesProp: this.addquesProp,
      editorOption: {
        // Customize your toolbar options here
        modules: {
          toolbar: [
            ["bold", "italic", "underline"],
            [
              {
                list: "ordered",
              },
              {
                list: "bullet",
              },
            ],
          ],
        },
        preserveWhitespace: true, // Preserve consecutive spaces
        placeholder: this.placeHolder,
      },
    };
  },

  watch: {
    value(oldvs) {
      this.editorContent = oldvs;
    },

    addquesProp(val) {
      if (val) {
        this.editorContent = "";
        this.$emit("validationVal", false);
      }
    },
    editorContent(newv, oldv) {
      this.$emit("questionText", newv);
      oldv = this.convertIntotext(oldv);
      newv = this.convertIntotext(newv);
      if ((oldv !== newv && newv.trim() === "") || newv == "") {
        this.$emit("validationVal", true);
        if (this.addquesProp) {
          this.changeaddquesProp = false;
          this.$emit("validationVal", false);
        }
      } else {
        this.$emit("validationVal", false);
      }
      this.$emit("addquesBack", this.changeaddquesProp);
    },
  },
  mounted() {},
  methods: {
    updateContent() {
      this.$emit("input", this.editorContent);
    },

    //Convert all the string with tags into STRING
    convertIntotext(allText) {
      const parser = new DOMParser();
      const htmlDoc = parser.parseFromString(allText, "text/html");
      const convertedText = htmlDoc.body.textContent || "";
      return convertedText;
    },
  },
};
</script>
<style>
.ql-editor {
  background-color: white;
  height: 230px;
  white-space: normal !important;
}

.ql-disabled .ql-editor {
  background-color: #e9ecef;
}

.validationError {
  border: 1px solid red !important;
}
</style>
